/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

var uploadDefaultProps = {
  allowUploadDuplicateFile: false,
  autoUpload: true,
  draggable: void 0,
  defaultFiles: [],
  isBatchUpload: false,
  max: 0,
  method: "POST",
  multiple: false,
  name: "file",
  showUploadProgress: true,
  theme: "file",
  uploadAllFilesInOneRequest: false,
  useMockProgress: true,
  withCredentials: false
};

export { uploadDefaultProps };
//# sourceMappingURL=defaultProps.js.map
